import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import CardActions from '@material-ui/core/CardActions'
import CardHeader from '@material-ui/core/CardHeader'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import InputAdornment from '@material-ui/core/InputAdornment'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import Fade from '@material-ui/core/Fade'

import red from '@material-ui/core/colors/red'
import indigo from '@material-ui/core/colors/indigo'
import green from '@material-ui/core/colors/green'

import CloseIcon from '@material-ui/icons/Close'
import VpnKeyIcon from '@material-ui/icons/VpnKey'

import { gameType, openingRuleItems, undoItems, OPENING_RULE, roomStatus, UNDO_SETTING, turnItems, TURN_SETTING } from '../../../constants'
import { makeLiveGameResultStr } from '../../../lib';
import { GameResultBox } from './CommonComponents';
import Word from '../../../containers/Common/Word'
import { WID } from '../../../constants/Language';
import { useState } from 'react'
import { useContext } from 'react'
import { GameContext } from '../GameProvider'

const styles = theme => ({
  card: {
    position: 'absolute',
    top: '48.5%',
    bottom: '51.5%',
    left: 0,
    right: 0,
    margin: 'auto',
    width: 300,
    height: 350,
    textAlign: 'left',
    zIndex: 100,
  },
  cardHeader: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`
  },
  cardActions: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: '100%',
    padding: theme.spacing.unit,
  },
  formControl: {
    width: '100%',
    maxWidth: 75,
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  gridRuleItem: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  textField: {
    width: 200,
  },
  win: {
    color: red[700],
    fontWeight: 900,
    fontSize: '2em',
  },
  lose: {
    color: indigo[700],
    fontWeight: 900,
    fontSize: '2em',
  },
  draw: {
    color: theme.palette.grey[500],
    fontWeight: 900,
  },
  buttonsGrid: {
    margin: 0,
  },
  buttonBaseBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing.unit * 2,
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.grey[100],
  },
})

const stylesForLiveGameSettingsCard = theme => ({
  card: {
    position: 'absolute',
    top: '48.5%',
    bottom: '51.5%',
    left: 0,
    right: 0,
    margin: 'auto',
    width: 300,
    height: 350,
    textAlign: 'left',
    zIndex: 100,
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[100],
  },
  action: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.grey[500],
    margin: - theme.spacing.unit / 2,
  }
})

const LiveGameSettingsCard = withStyles(stylesForLiveGameSettingsCard, { withTheme: true })(props => {
  const { title, openingRule, minute, increaseSecond, error, handleChange } = useContext(PopupMessageCardContext)
  const { classes, userSettings, handleResetSettings } = props

  const gameContext = useContext(GameContext)
  const { room } = gameContext

  return (
    <Fade in={room.status === roomStatus.EMPTY || room.status === roomStatus.WAIT}>
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          classes={{ action: classes.action }}
          subheader={<Word wid={WID.POPUP_MESSAGE_CARD.CARD_TITLE}/>}
          action={room.lock ? (<VpnKeyIcon/>) : undefined}
        />
        <LiveGameSettingsCardContent {...{ userSettings, room, title, openingRule, minute, increaseSecond, error, handleChange }}/>
        <LiveGameSettingsCardActions {...{ userSettings, room, title, openingRule, minute, increaseSecond, error, handleResetSettings }}/>
      </Card>
    </Fade>
  )
})

const stylesForLiveGameSettingsCardContent = theme => ({
  formControl: {
    width: '100%',
    maxWidth: 75,
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  gridRuleItem: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  textField: {
  },
  cardContent: {
    height: '200px',
    boxSizing: 'border-box',
    overflowY: 'scroll' 
  },
  label: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
    lineHeight: 1,
    marginBottom: theme.spacing.unit,
  },
  minuteInput: {
    width: 55,
  },
  secondsInput: {
    width: 55,
  },
  sentence: {
  }
})

const LiveGameSettingsCardContent = withStyles(stylesForLiveGameSettingsCardContent, { withTheme: true })(props => {
  const { classes, userSettings, room } = props
  
  var isOwner, styles
  isOwner = Boolean(userSettings !== undefined && room.owner !== undefined && userSettings.userName === room.owner.userName)
  styles = {
    cardContent: {
      paddingTop: isOwner === true && room.status === roomStatus.EMPTY ? 0 : undefined,
    }
  }

  return (
    <CardContent className={classes.cardContent} style={styles.cardContent}>
      {isOwner === true && room.status === roomStatus.EMPTY ? (
        <LiveGameSettingsCardFormContent {...{room}}/>
      ) : room.status === roomStatus.WAIT ? (
        <LiveGameSettingsCardWaitContent {...{room, isOwner}}/>
      ) : (
        <Grid container>
          <Grid item xs={12} className={classes.gridRuleItem}>
            <Typography className={classes.label}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TITLE_LABEL}/></Typography>
            <Typography className={classes.sentence}>-</Typography>
          </Grid>
          <Grid item xs={6} className={classes.gridRuleItem}>
            <Typography className={classes.label}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.OPENING_RULE_LABEL}/></Typography>
            <Typography className={classes.sentence}>-</Typography>
          </Grid>
          <Grid item xs={3} className={classes.gridRuleItem}>
            <Typography className={classes.label}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TIME_LABEL}/></Typography>
            <Typography className={classes.sentence}>-</Typography>
          </Grid>
          <Grid item xs={3} className={classes.gridRuleItem}>
            <Typography className={classes.label}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TIME_INCREMENTS_LABEL}/></Typography>
            <Typography className={classes.sentence}>-</Typography>
          </Grid>
          <Grid item xs={6} className={classes.gridRuleItem}>
            <Typography className={classes.label}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TURN_LABEL}/></Typography>
            <Typography className={classes.sentence}>-</Typography>
          </Grid>
          <Grid item xs={3} className={classes.gridRuleItem}>
            <Typography className={classes.label}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.UNDO_LABEL}/></Typography>
            <Typography className={classes.sentence}>-</Typography>
          </Grid>
        </Grid>
      )}
    </CardContent>
  )
})

const LiveGameSettingsCardFormContent = withStyles(stylesForLiveGameSettingsCardContent, { withTheme: true })(props => {
  const { title, openingRule, minute, increaseSecond, turn, enableUndo, error, handleChange } = useContext(PopupMessageCardContext)
  const { classes } = props

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField
          error={error.title}
          label={<Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TITLE_LABEL}/>}
          value={title}
          onChange={handleChange('title')}
          className={classes.textField}
          margin='normal'
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label={<Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.OPENING_RULE_LABEL}/>}
          select
          value={openingRule}
          onChange={handleChange('openingRule')}
          className={classes.textField}
          margin='normal'
        >
          {openingRuleItems.filter(item => item.value !== OPENING_RULE.NONE).map(item =>
            <MenuItem key={item.value} value={item.value}>
              <Typography>
                <Word wid={item.wid}/>
              </Typography>
            </MenuItem>
          )}
        </TextField>
      </Grid>
      <Grid item xs={3}>
        <FormControl className={classes.formControl}>
          <InputLabel style={{whiteSpace: 'nowrap'}}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TIME_LABEL}/></InputLabel>
          <Input
            error={error.minute}
            value={minute}
            onChange={handleChange('minute')}
            type='number'
            endAdornment={<InputAdornment position="end"><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.MINUTE}/></InputAdornment>}
            inputprops={{ textAlign: 'center' }}
            className={classes.minuteInput}
          />
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <FormControl className={classes.formControl}>
          <InputLabel style={{whiteSpace: 'nowrap'}}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TIME_INCREMENTS_LABEL}/></InputLabel>
          <Input
            error={error.increaseSecond}
            value={increaseSecond}
            onChange={handleChange('increaseSecond')}
            type='number'
            endAdornment={<InputAdornment position="end"><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.SECONDS}/></InputAdornment>}
            inputprops={{ textAlign: 'center' }}
            className={classes.secondsInput}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <TextField
          label={<Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TURN}/>}
          select
          value={turn}
          onChange={handleChange('turn')}
          className={classes.textField}
          margin='normal'
        >
          {turnItems.filter(item => item.value !== OPENING_RULE.NONE).map(item =>
            <MenuItem key={item.value} value={item.value}>
              <Typography>
                <Word wid={item.wid}/>
              </Typography>
            </MenuItem>
          )}
        </TextField>
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={<Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.UNDO}/>}
          select
          value={enableUndo}
          onChange={handleChange('enableUndo')}
          className={classes.textField}
          margin='normal'
        >
          {undoItems.map(item =>
            <MenuItem key={item.value} value={item.value}>
              <Typography>
                <Word wid={item.wid}/>
              </Typography>
            </MenuItem>
          )}
        </TextField>
      </Grid>
    </Grid>
  )
})


const LiveGameSettingsCardWaitContent = withStyles(stylesForLiveGameSettingsCardContent, { withTheme: true })(props => {
  const { classes, room, isOwner } = props

  var item, title, openingRuleLabel, timeLimit, increaseTime, undo, turn
  title = room.title ? room.title : "-"
  item = openingRuleItems.find(it => it.value === room.openingRule)
  openingRuleLabel = item !== undefined ? <Word wid={item.wid}/> : ''
  timeLimit = room.minute !== undefined ? room.minute : ''
  increaseTime = room.increaseSecond !== undefined ? room.increaseSecond : ''
  item = undoItems.find(item => Boolean(parseInt(item.value, 10)) === room.enableUndo)
  undo = item ? item.wid : ''
  item = turnItems.find(item => item.value === room.turnType)
  turn = item ? isOwner ? item.wid : item.wid2 : ''

  return (
    <Grid container>
      <Grid item xs={12} className={classes.gridRuleItem}>
        <Typography className={classes.label}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TITLE_LABEL}/></Typography>
        <Typography className={classes.sentence}>{title}</Typography>
      </Grid>

      <Grid item xs={6} className={classes.gridRuleItem}>
        <Typography className={classes.label}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.OPENING_RULE_LABEL}/></Typography>
        <Typography className={classes.sentence}>{openingRuleLabel}</Typography>
      </Grid>

      <Grid item xs={3} className={classes.gridRuleItem}>
        <Typography className={classes.label}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TIME_LABEL}/></Typography>
        <Typography className={classes.sentence}>{timeLimit} <Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.MINUTE}/></Typography>
      </Grid>

      <Grid item xs={3} className={classes.gridRuleItem}>
        <Typography className={classes.label}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TIME_INCREMENTS_LABEL}/></Typography>
        <Typography className={classes.sentence}>{increaseTime} <Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.SECONDS}/></Typography>
      </Grid>

      <Grid item xs={6} className={classes.gridRuleItem}>
        <Typography className={classes.label}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TURN_LABEL}/></Typography>
        <Typography className={classes.sentence}><Word wid={turn}/></Typography>
      </Grid>

      <Grid item xs={3} className={classes.gridRuleItem}>
        <Typography className={classes.label}><Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.UNDO_LABEL}/></Typography>
        <Typography className={classes.sentence}><Word wid={undo}/></Typography>
      </Grid>
    </Grid>
  )
})


const stylesForLiveGameSettingsCardActions = theme => ({
  cardActions: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: '100%',
    padding: theme.spacing.unit,
  },
  buttonsGrid: {
    margin: 0,
  },
  buttonBaseBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing.unit * 2,
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.grey[100],
  },
})

const LiveGameSettingsCardActions = withStyles(stylesForLiveGameSettingsCardActions, { withTheme: true })(props => {
  const { title, openingRule, minute, increaseSecond, enableUndo, turn, error, setOpeningRule, setTitle, setMinute, setIncreaseSecond, setEnableUndo, setTurn } = useContext(PopupMessageCardContext)
  const { classes, theme, userSettings, room } = props
  var styles, player, ready, data, isOwner, disabledJoinButton, disabledReadyButton, disabledSettingsButton
  data = {
    groupName: room.groupName,
    roomName: room.name,
    title,
    gameType: gameType.LIVE_GAME,
    openingRule,
    minute: parseInt(minute, 10),
    increaseSecond: parseInt(increaseSecond, 10),
    enableUndo: Boolean(parseInt(enableUndo, 10)),
    turnType: turn
  }
  player = userSettings === undefined ? undefined :
           room.player1 !== undefined && userSettings.userName === room.player1.userName ? room.player1 :
           room.player2 !== undefined && userSettings.userName === room.player2.userName ? room.player2 : undefined
  ready = player !== undefined ? player.ready : undefined
  isOwner = Boolean(userSettings !== undefined && room.owner !== undefined && userSettings.userName === room.owner.userName)
  disabledJoinButton = Boolean(userSettings === undefined || (room.player1 !== undefined && room.player2 !== undefined))
  disabledSettingsButton = !isOwner || error.title || error.minute || error.increaseSecond
  disabledReadyButton = Boolean(room.player1 === undefined || room.player2 === undefined || player === undefined || room.status !== roomStatus.WAIT)
  styles = {
    readyButton: {
      backgroundColor: Boolean(ready) === false && disabledReadyButton === false ? green[500] : undefined,
      color: Boolean(ready) === false && disabledReadyButton === false ? theme.palette.common.white : undefined,
    }
  }

  const gameContext = useContext(GameContext)

  const handleResetSettings = () => {
    gameContext.resetGameSettings(room.groupName, room.name)
    setOpeningRule(room.openingRule)
    setTitle(room.title)
    setMinute(room.minute)
    setIncreaseSecond(room.increaseSecond)
    setEnableUndo(room.enableUndo ? "1" : "0")
    setTurn(room.turnType)
  }


  return (
    <CardActions className={classes.cardActions}>
      {player === undefined ? (
        <Grid container spacing={8} className={classes.buttonsGrid}>
          <Grid item xs={12}>
            <Button className={classes.button} fullWidth variant='contained' color='primary' onClick={() => gameContext.joinGame(room.groupName, room.name)} disabled={disabledJoinButton}>
              <Word wid={WID.LIVE_GAME_SETTINGS_CARD_ACTIONS.ENTER_BUTTON}/>
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={8} className={classes.buttonsGrid}>
          <Grid item xs={6}>
            <Button className={classes.button} fullWidth variant='contained' onClick={() => gameContext.leaveGame(room.groupName, room.name)}>
              <Word wid={WID.LIVE_GAME_SETTINGS_CARD_ACTIONS.LEAVE_BUTTON}/>
            </Button>
          </Grid>
          <Grid item xs={6}>
            {room.status === roomStatus.EMPTY ? (
              <Button className={classes.button} fullWidth variant='contained' color='primary' onClick={() => gameContext.gameSettings(data)} disabled={disabledSettingsButton}>
                <Word wid={WID.LIVE_GAME_SETTINGS_CARD_ACTIONS.COPLETE_SETTINGS_BUTTON}/>
              </Button>
            ) : (
              <Button className={classes.button} fullWidth variant='contained' onClick={handleResetSettings} disabled={disabledSettingsButton}>
                <Word wid={WID.LIVE_GAME_SETTINGS_CARD_ACTIONS.CHANGE_SETTINGS_BUTTON}/>
              </Button>
            )}
          </Grid>
          <Grid item xs={12}>
            <Button className={classes.button} fullWidth variant='contained' disabled={disabledReadyButton} onClick={() => gameContext.ready(room.groupName, room.name, !Boolean(ready))} style={styles.readyButton} >
              {Boolean(ready) ? 'Cancel' : 'OK'}
            </Button>
          </Grid>
        </Grid>
      )}
    </CardActions>
  )
})

const stylesForLiveGameEndCard = theme => ({
  card: {
    position: 'absolute',
    top: '48.5%',
    bottom: '51.5%',
    left: 0,
    right: 0,
    margin: 'auto',
    width: 300,
    height: 350,
    textAlign: 'left',
    zIndex: 100,
  },
  cardContent: {
    height: 'calc(100% - 96px - 52px)',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[100],
  },
  cardHeaderAction: {
    display: 'flex',
    margin: 0,
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.grey[700],
  },
  win: {
    color: red[700],
    fontWeight: 900,
    fontSize: '2em',
  },
  lose: {
    color: indigo[700],
    fontWeight: 900,
    fontSize: '2em',
  },
  draw: {
    color: theme.palette.grey[500],
    fontWeight: 900,
  },
  playerResultBox: {
    textAlign: 'center'
  },
  playerResultAvatar: {
    width: theme.spacing.unit * 8,
    height: theme.spacing.unit * 8,
    margin: `${theme.spacing.unit * 2}px auto`,
  },
  reasonBox: {
    padding: theme.spacing.unit * 2
  }, 
  gameResultStr: {
    marginTop: theme.spacing.unit * 3,
    color: theme.palette.grey[700]
  },
  action: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.grey[500],
    margin: - theme.spacing.unit / 2,
  }
})

class LiveGameEndCard extends React.Component {
  state = {
    open: true,
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { classes, userSettings, room } = this.props
    const { open } = this.state
    return (
      <Fade in={open} style={{ transitionDelay: open ? '2000ms' : '0ms' }}>
        <Card className={classes.card}>
          <CardHeader
            subheader={<Word wid={WID.POPUP_MESSAGE_CARD.CARD_TITLE}/>}
            className={classes.cardHeader}
            classes={{ action: classes.action }}
            action={<CloseIcon color='inherit' onClick={this.handleClose}/>}
          />
          <CardContent className={classes.cardContent}>
            <div>
              <GameResultBox gameResult={room.gameResult}/>
              <Typography className={classes.gameResultStr} align='center'>
                {makeLiveGameResultStr(room.gameResult)}
              </Typography>
            </div>
          </CardContent>
          <LiveGameEndCardActions {...{ userSettings, room }}/>
        </Card>
      </Fade>
    )
  }
}

LiveGameEndCard = withStyles(stylesForLiveGameEndCard, { withTheme: true })(LiveGameEndCard)

const stylesForLiveGameEndCardActions = theme => ({
  cardActions: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: '100%',
    padding: theme.spacing.unit,
  },
})

const LiveGameEndCardActions = withStyles(stylesForLiveGameEndCardActions, { withTheme: true })(props => {
  const { classes, userSettings, room } = props
  var player, disabledJoinButton, disalbedNewGameButton, disabledRestartButton
  player = userSettings === undefined ? undefined :
           room.player1 !== undefined && userSettings.userName === room.player1.userName ? room.player1 :
           room.player2 !== undefined && userSettings.userName === room.player2.userName ? room.player2 : undefined
  disabledJoinButton = Boolean(
    userSettings === undefined ||
    (room.player1 !== undefined && room.player2 !== undefined)
  )
  disalbedNewGameButton = Boolean(
    room.status !== roomStatus.END ||
    room.owner === undefined || userSettings === undefined ||
    room.owner.userName !== userSettings.userName
  )
  disabledRestartButton = Boolean(
    room.status !== roomStatus.END ||
    room.owner === undefined || userSettings === undefined ||
    room.owner.userName !== userSettings.userName ||
    room.player1 === undefined || room.player2 === undefined
  )

  const gameContext = useContext(GameContext)

  return (
    <CardActions className={classes.cardActions}>
      {player === undefined ? (
        <Grid container spacing={8} className={classes.buttonsGrid}>
          <Grid item xs={12}>
            <Button className={classes.button} fullWidth variant='contained' color='primary' onClick={() => gameContext.joinGame(room.groupName, room.name)} disabled={disabledJoinButton}>
              <Word wid={WID.LIVE_GAME_END_CARD_ACTIONS.ENTER_BUTTON}/>
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={8} className={classes.buttonsGrid}>
          <Grid item xs={6}>
            <Button className={classes.button} fullWidth variant='contained' onClick={() => gameContext.newGame(room.groupName, room.name)} disabled={disalbedNewGameButton}>
              <Word wid={WID.LIVE_GAME_END_CARD_ACTIONS.NEW_GAME_BUTTON}/>
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button className={classes.button} fullWidth variant='contained' onClick={() => gameContext.restartGame(room.groupName, room.name)} disabled={disabledRestartButton}>
              <Word wid={WID.LIVE_GAME_END_CARD_ACTIONS.REMATCH_BUTTON}/>
            </Button>
          </Grid>
          <Grid item xs={12}>
            {player === undefined ? (
              <Button className={classes.button} fullWidth variant='contained' color='primary' onClick={() => gameContext.joinGame(room.groupName, room.name)} disabled={disabledJoinButton}>
                <Word wid={WID.LIVE_GAME_END_CARD_ACTIONS.ENTER_BUTTON}/>
              </Button>
            ) : (
              <Button className={classes.button} fullWidth variant='contained' onClick={() => gameContext.leaveGame(room.groupName, room.name)}>
                <Word wid={WID.LIVE_GAME_END_CARD_ACTIONS.LEAVE_BUTTON}/>
              </Button>
            )}
          </Grid>
        </Grid>
      )}
    </CardActions>
  )
})


const PopupMessageCardContext = React.createContext()

function PopupMessageCardProvider(props) {
  const { children } = props

  const [openingRule, setOpeningRule] = useState(OPENING_RULE.FREE)
  const [title, setTitle] = useState('')
  const [minute, setMinute] = useState('5')
  const [increaseSecond, setIncreaseSecond] = useState('0')
  const [enableUndo, setEnableUndo] = useState(UNDO_SETTING.OK)
  const [turn, setTurn] = useState(TURN_SETTING.RANDOM)
  const [error, setError] = useState({
    title: false,
    minute: false,
    increaseSecond: false
  })

  const handleChange = (name) => (event) => {
    var val, isError
    isError = {}
    switch (name) {
      case 'openingRule':
        setOpeningRule(event.target.value)
        break
      case 'title':
        isError.title = Boolean(event.target.value > 20)
        setTitle(event.target.value)
        break
      case 'minute': 
        val = parseInt(event.target.value, 10)
        isError.minute = Boolean(isNaN(val) || 1 > val || 60 < val)
        setMinute(event.target.value)
        break
      case 'increaseSecond':
        val = parseInt(event.target.value, 10)
        isError.increaseSecond = Boolean(isNaN(val) || 0 > val || 60 < val)
        setIncreaseSecond(event.target.value)
        break
      case 'enableUndo':
        setEnableUndo(event.target.value)
        break
      case 'turn':
        setTurn(event.target.value)
        break
      default:
        break
    }
    setError({ ...error, ...isError })
  }

  return (
    <PopupMessageCardContext.Provider
      value={{
        openingRule,
        setOpeningRule,
        title,
        setTitle,
        minute,
        setMinute,
        increaseSecond,
        setIncreaseSecond,
        enableUndo,
        setEnableUndo,
        turn,
        setTurn,
        error,
        handleChange
      }}
    >
      {children}
    </PopupMessageCardContext.Provider>
  )
}

function PopupMessageCard(props) {
  const { userSettings, room, handleResetSettings } = props

  switch (room.gameType) {
    case gameType.LIVE_GAME:
      switch (room.status) {
        case roomStatus.EMPTY:
        case roomStatus.WAIT:
          return (
            <PopupMessageCardProvider>
              <LiveGameSettingsCard {...{ userSettings, room, handleResetSettings }}/>
            </PopupMessageCardProvider>
          )
        case roomStatus.PLAYING:
          return (<React.Fragment></React.Fragment>)
        case roomStatus.END:
          return (
            <PopupMessageCardProvider>
              <LiveGameEndCard {...{ userSettings, room }}/>
            </PopupMessageCardProvider>
          )
        default:
          return (<React.Fragment></React.Fragment>)
      }
    case gameType.DAILY_GAME:
      return (<React.Fragment></React.Fragment>)
    default: 
      return (<React.Fragment></React.Fragment>)
  }
}

export default withStyles(styles, { withTheme: true })(PopupMessageCard)


// WEBPACK FOOTER //
// ./src/Pages/Game/components/PopupMessageCard.js